import styled from 'styled-components';
import { Layout } from '../../components/Layout';

export const SectionHeading = styled(Layout.SectionHeading)`
  margin-bottom: 0.5rem;
`;
